import { render } from "./ListeTypeHospitalisation.vue?vue&type=template&id=c2bab284"
import script from "./ListeTypeHospitalisation.vue?vue&type=script&lang=js"
export * from "./ListeTypeHospitalisation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__